import { createReducer, on } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from '../actions';
import { setHartfordCoverPageInfo } from './hartford-cover-page.actions';
import { AS_OF_DATE_LATEST } from 'CustomPDFReportsApp/ts/constants';
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
export const hartfordCoverPageInfo = createReducer({
    clientName: null,
    clientID: null,
    firmName: null,
    modelNames: null,
    asOfDateOption: AS_OF_DATE_LATEST,
    designationType: CustomPDFReportDesignation.DELIVERABLE,
}, on(setHartfordCoverPageInfo, (state, { clientName, clientID, firmName, modelNames, asOfDateOption, designationType }) => {
    return {
        clientName,
        clientID,
        firmName,
        modelNames,
        asOfDateOption,
        designationType,
    };
}), on(resetAllCustomPdfReportItems, () => {
    return {
        clientName: null,
        clientID: null,
        firmName: null,
        modelNames: null,
        asOfDateOption: AS_OF_DATE_LATEST,
        designationType: CustomPDFReportDesignation.DELIVERABLE,
    };
}));
